/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type tradeEnrollmentAndStatusUpdateQueryVariables = {};
export type tradeEnrollmentAndStatusUpdateQueryResponse = {
    readonly viewer: {
        readonly isEnrollmentAndStatusUpdateEnabled: boolean | null;
    } | null;
};
export type tradeEnrollmentAndStatusUpdateQuery = {
    readonly response: tradeEnrollmentAndStatusUpdateQueryResponse;
    readonly variables: tradeEnrollmentAndStatusUpdateQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": "isEnrollmentAndStatusUpdateEnabled",
  "name": "isEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "enableTradeEnrollmentAndStatusUpdate"
    }
  ],
  "storageKey": "isEnabled(key:\"enableTradeEnrollmentAndStatusUpdate\")"
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "tradeEnrollmentAndStatusUpdateQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "tradeEnrollmentAndStatusUpdateQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "tradeEnrollmentAndStatusUpdateQuery",
    "id": "ferrum/246.0.0-2020-01-07T17:04:52.253Z/tradeEnrollmentAndStatusUpdateQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '74ea43f0d8a1db58141e84c836a30a00';
export default node;
